import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-warning',
  templateUrl: './icon-warning.component.html',
  styleUrls: ['./icon-warning.component.scss']
})
export class IconWarningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
